import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VConsole from 'vconsole';
import Vant from 'vant';
import 'vant/lib/index.css';
import okToast from "@/components/c-toast/toast";
import webokToast from "@/components/web-toast/toast";
import { initUrl } from "@/utils/index";
initUrl()
Vue.use(okToast); // 注册插件
Vue.use(webokToast); // 注册插件
Vue.use(Vant);
Vue.use(ElementUI)
Vue.config.productionTip = false
import "./utils/flexible"
import "@/assets/css/swiper_animate.min.css"
import "@/assets/css/swiper-bundle.min.css"
import "@/assets/css/animate.min.css"
import "@/assets/css/viewer.min.css"
const Swiper = require('@/assets/js/swiper-bundle.min.js')
const Viewer = require('@/assets/js/viewer.min.js')
if (process.env.NODE_ENV == 'development') {//使用环境变量进行判断
  const vConsole = new VConsole();
}
if (process.env.NODE_ENV !== 'development') {
  if (window) {
    window.console.log = function () {};
  }
}
window.Swiper = Swiper
window.Viewer = Viewer
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


